// @ts-nocheck
import { linkStyles } from "@store/Themes/common/mixins/link";
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const link: Styleguide["link"] = {
    defaultProps: {
        color: null as any,
        hoverStyle: null as any,
        hoverMode: null as any,
        typographyProps: { weight: "bold" } /* Store Custom Code */,
        css: linkStyles("text.link", "text.linkHover", false, true),
    },
};

export default link;
